import strFunc from "@/lib/lyg/string";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";

function MessageListArea(props: any) {
  let myProps = {
    msg_arr: [],
    set_msg_arr: (inData: any) => { },
    Style: {} as any,
    ...props
  };
  let msg_arr = myProps.msg_arr;
  let Style = myProps.Style;

  const on_change_msg_input = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      idx: -1,
      ...inData
    };
    let name = opt_obj.name;
    let value = opt_obj.value;
    let idx = opt_obj.idx;
    let new_msg_arr = [...msg_arr];
    if (new_msg_arr[idx]) {
      let change_msg_row = { ...new_msg_arr[idx] };
      change_msg_row[name] = value;
      new_msg_arr[idx] = change_msg_row;
      myProps.set_msg_arr(new_msg_arr);
    }
  };

  const get_msg_row_tags = () => {
    let msg_tags: any = msg_arr.map((msg_row: any, idx: number) => {
      return (
        <div key={idx} className={Style.msg_item}>
          <div className={Style.msg_row_header}>
            <span className={Style.msg_num}>{idx + 1}</span>
            <span className={Style.room_label}>방이름</span>
            <input type="text" className={Style.room_input} name="room_name" value={msg_row.room_name}
              onChange={(e) => {
                on_change_msg_input({ name: "room_name", value: e.target.value, idx: idx });
              }}
              placeholder="채팅방 이름 입력"></input>
          </div>
          <div>
            <TextAreaComponent
              className={Style.msg_textarea}
              style={{ borderRadius: "5px", background: "#fff" }}
              name="message"
              value={msg_row.message}
              onChange={(e: any) => {
                on_change_msg_input({ name: "message", value: e.target.value, idx: idx });
              }}
              placeholder="메시지 내용"
            ></TextAreaComponent>
          </div>
        </div>
      );
    });

    if (strFunc.is_empty(msg_tags)) {
      msg_tags = (
        <div className={Style.empty_msg}>
          <div className={Style.empty_icon}>📭</div>
          <div>메시지 내역이 없습니다.</div>
        </div>
      );
    }

    return msg_tags;
  };

  return (
    <div className={Style.msg_section}>
      <div className={Style.msg_header}>
        <h3>
          메시지 내역
          <span className={Style.msg_count}>{msg_arr.length}건</span>
        </h3>
      </div>
      <div>
        {get_msg_row_tags()}
      </div>
    </div>
  );
};
export default MessageListArea;